import {AlternativeAutoComplete} from 'common/form/autoComplete/_alternativeAutoComplete'
import addressData from './old_data.json'
import {useTranslation} from 'react-i18next'
import {useEffect, useState} from 'react'
import StringUtils from 'util/stringUtils'
import ArrayUtils from 'util/array'
import {StyledOldAddress} from './styled'
import {Text} from '../text'
import {THEME_SEMANTICS} from '../theme/_semantics'
import {AutoCompleteSingleOption} from '../form/autocompleteSingleOption'
import {OldAddressSplit} from './oldAddressSplit'

export const provinceOldData = addressData.map(data => ({
   name: data?.name || '---',
   value: data?.id || '',
   id: data?.id || '',
   list: data?.list?.map(district => ({
      value: district.id,
      id: district.id,
      name: district.name,
      list: district?.list?.map(ward => ({
         value: ward.id,
         id: ward.id,
         name: ward.name,
      })),
   })),
}))

export const OldAddressBlock = ({province, district, ward, showLabel = true, hiddenCategory = true, require = true, ...props}) => {
   const {t} = useTranslation()
   const [validateGroup, setValidateGroup] = useState('')
   const [validateProvince, setValidateProvince] = useState(province?.validate || '')
   const [validateWard, setValidateWard] = useState(ward?.validate || '')
   const [validateDistrict, setValidateDistrict] = useState(district?.validate || '')
   const [provinceKeyword, setProvinceKeyword] = useState('')
   const [provinceValue, setProvinceValue] = useState(null)
   const [provinceList, setProvinceList] = useState(provinceOldData || [])
   const [districtKeyword, setDistrictKeyword] = useState('')
   const [districtValue, setDistrictValue] = useState(null)
   const [districtList, setDistrictList] = useState([])
   const [districtListOrigin, setDistrictListOrigin] = useState([])
   const [wardKeyword, setWardKeyword] = useState('')
   const [wardValue, setWardValue] = useState(null)
   const [wardList, setWardList] = useState([])
   const [wardListOrigin, setWardListOrigin] = useState([])

   const handleProvinceValidate = boo => {
      !!boo ? setValidateProvince('')
         : setValidateProvince(
         <div style={{position: 'relative'}}>
            <span
               style={{position: 'absolute', top: 0, left: 0, width: '200px'}}
            >
              {t('province_required')}
            </span>
         </div>
         )
   }
   const onProvinceKeywordChange = (data) => {
      const formatDataValue = data?.value
         ? StringUtils.removeAccents(data?.value?.toLowerCase())
         : ''

      const listData = provinceOldData.filter(item => {
         const formatNameItem = item?.name
            ? StringUtils.removeAccents(item.name.toLowerCase())
            : ''
         if (formatNameItem.includes(formatDataValue.trim())) return true
         return false
      })
      setProvinceKeyword(data?.value)
      setProvinceList(listData)
   }
   const onProvinceChange = (data) => {
      handleProvinceValidate(true)
      setProvinceValue(data)
      setDistrictList(
         ArrayUtils.getQualifiedArray(data?.list).map(
            (district) => (
               {
                  name: district?.name || '---',
                  value: district?.id || district?.value || '',
                  list: district?.list || []
               }
            )
         )
      )
      setDistrictListOrigin(
         ArrayUtils.getQualifiedArray(data?.list).map(
            (district) => (
               {
                  name: district?.name || '---',
                  value: district?.id || district?.value || '',
                  list: district?.list || []
               }
            )
         )
      )
      setDistrictValue(null)
      setWardValue(null)
      if (province?.onChange) province.onChange(data)
   }

   const handleDistrictValidate = boo => {
      !!boo ? setValidateDistrict('')
         : setValidateDistrict(
         <div style={{position: 'relative'}}>
            <span
               style={{position: 'absolute', top: 0, left: 0, width: '200px'}}
            >
              {t('district_required')}
            </span>
         </div>
         )
   }
   const onDistrictKeywordChange = (data) => {
      setDistrictKeyword(data?.value)
      const formatDataValue = data?.value
         ? StringUtils.removeAccents(data?.value?.toLowerCase())
         : ''

      const listData = districtListOrigin.filter(item => {
         const formatNameItem = item?.name
            ? StringUtils.removeAccents(item.name.toLowerCase())
            : ''
         if (formatNameItem.includes(formatDataValue.trim())) return true
         return false
      })
      setDistrictList(listData)
   }
   const onDistrictChange = (data) => {
      handleDistrictValidate(true)
      setDistrictValue(data)
      setWardList(
         ArrayUtils.getQualifiedArray(data?.list).map(
            (data) => (
               {
                  name: data?.name || '---',
                  value: data?.id || data?.value || '',
               }
            )
         )
      )
      setWardListOrigin(
         ArrayUtils.getQualifiedArray(data?.list).map(
            (data) => (
               {
                  name: data?.name || '---',
                  value: data?.id || data?.value || '',
               }
            )
         )
      )
      setWardValue(null)
      if (district?.onChange) district.onChange(data)
   }
   const handleWardValidate = boo => {
      !!boo ? setValidateWard('')
         : setValidateWard(
         <div style={{position: 'relative'}}>
            <span
               style={{position: 'absolute', top: 0, left: 0, width: '200px'}}
            >
              {t('ward_required')}
            </span>
         </div>
         )
   }
   const onWardKeywordChange = (data) => {
      setWardKeyword(data?.value)
      const formatDataValue = data?.value
         ? StringUtils.removeAccents(data?.value?.toLowerCase())
         : ''

      const listData = wardListOrigin.filter(item => {
         const formatNameItem = item?.name
            ? StringUtils.removeAccents(item.name.toLowerCase())
            : ''
         if (formatNameItem.includes(formatDataValue.trim())) return true
         return false
      })
      setWardList(listData)
   }
   const onWardChange = (data) => {
      handleWardValidate(true)
      setWardValue(data)
      if (ward?.onChange) ward.onChange(data)
   }

   useEffect(() => {
      if (province?.value?.value !== provinceValue?.value) {
         onProvinceChange(provinceOldData.find(item => +item?.value === +province?.value?.value))
      }
      if (district?.value?.value !== districtValue?.value) {
         onDistrictChange(district?.value)
      }
      if (ward?.value?.value !== wardValue?.value) {
         onWardChange(ward?.value)
      }
   }, [province?.value, district?.value, ward?.value])

   useEffect(() => {
      setValidateProvince(province?.validate)
      setValidateDistrict(district?.validate)
      setValidateWard(ward?.validate)
      if (!!province?.validate || !!district?.validate || !!ward?.validate || !!props?.addressSplit?.validateText)
         setValidateGroup('address_incomplete')
      else setValidateGroup('')
   }, [province?.validate, district?.validate, ward?.validate, props?.addressSplit?.validateText])

   return (
      <StyledOldAddress>
         <div style={{marginBottom: 16}}>
            <OldAddressSplit
               showLabel={showLabel}
               province={province}
               district={district}
               ward={ward}
               onChange={value => props?.addressSplit?.onChange(value)}
               onSetUnit={props?.onSetUnit}
               value={props?.addressSplit?.value}
               unitVersion={props?.unitVersion}
               validateText={props?.size === 'sm' ? props?.addressSplit?.validateText ? (<>&nbsp;</>) : '' : props?.addressSplit?.validateText}
            />
         </div>
         <div className="address-container" data-gap={props?.gap} data-block={!!props?.isBlock} data-size={props?.size}>
            <div className="province-container">
               <AlternativeAutoComplete
                  {...props}
                  // main input
                  inputProps={{
                     label: !!showLabel ? <Text>{t('city_name')} {!!require &&
                     <Text color={THEME_SEMANTICS.failed}>*</Text>}</Text> : '',
                     categoryList: [], // menu list in category dropdown
                     categoryValue: {name: t('city_name'), value: ''}, // if not exist this value -> default category: categoryList[0]
                     categoryWidth: 140,
                     categoryHidden: hiddenCategory,
                     placeholder: t('select_province'),
                     readOnly: true,
                     value: provinceValue?.name || '',
                     validateText: props?.size === 'sm' ? validateProvince ? (<>&nbsp;</>) : '' : validateProvince,
                     validateType: 'danger',
                  }}
                  // search menu dropdown
                  menuProps={{
                     // style: {
                     //   bottom: props?.placement === 'top' ? 40 : 'initial',
                     //   top: props?.placement === 'top' ? 'initial' : 'calc(100% + 4px)',
                     // },
                     empty:
                        provinceList.length <= 0 ? t('city_no_data') : '',
                  }}
                  // search input in dropdown menu
                  searchInputProps={{
                     placeholder: t('search_city'),
                     value: provinceKeyword || '',
                     onChange: onProvinceKeywordChange,
                  }}
               >
                  {provinceList.length > 0 &&
                  provinceList.map(item => (
                     <AutoCompleteSingleOption
                        key={item.value}
                        data-active={item.value === provinceValue?.value}
                        onClick={() => onProvinceChange(item)}
                     >
                        {item.name}
                     </AutoCompleteSingleOption>
                  ))}
               </AlternativeAutoComplete>
            </div>
            <div className="district-container">
               <AlternativeAutoComplete
                  {...props}
                  // main input
                  inputProps={{
                     label: !!showLabel ? <Text>{t('district_name')} {!!require &&
                     <Text color={THEME_SEMANTICS.failed}>*</Text>}</Text> : '',
                     categoryList: [], // menu list in category dropdown
                     categoryValue: {name: t('district_name'), value: ''}, // if not exist this value -> default category: categoryList[0]
                     categoryWidth: 140,
                     categoryHidden: hiddenCategory,
                     placeholder: t('select_district'),
                     readOnly: true,
                     value: districtValue?.name || '',
                     validateText: props?.size === 'sm' ? validateDistrict ? (<>&nbsp;</>) : '' : validateDistrict,
                     validateType: 'danger',
                     disabled: !!!provinceValue?.value,
                  }}
                  // search menu dropdown
                  menuProps={{
                     // style: {
                     //   bottom: props?.placement === 'top' ? 40 : 'initial',
                     //   top: props?.placement === 'top' ? 'initial' : 'calc(100% + 4px)',
                     // },
                     empty:
                        districtList.length <= 0 ? t('district_no_data') : '',
                  }}
                  // search input in dropdown menu
                  searchInputProps={{
                     placeholder: t('search_district'),
                     value: districtKeyword || '',
                     onChange: onDistrictKeywordChange,
                  }}
               >
                  {districtList.length > 0 &&
                  districtList.map(item => (
                     <AutoCompleteSingleOption
                        key={item.value}
                        data-active={item.value === districtValue?.value}
                        onClick={() => onDistrictChange(item)}
                     >
                        {item.name}
                     </AutoCompleteSingleOption>
                  ))}
               </AlternativeAutoComplete>
            </div>
            <div className="ward-container">
               <AlternativeAutoComplete
                  {...props}
                  // main input
                  inputProps={{
                     label: !!showLabel ? <Text>{t('ward_name')} {!!require &&
                     <Text color={THEME_SEMANTICS.failed}>*</Text>}</Text> : '',
                     categoryList: [], // menu list in category dropdown
                     categoryValue: {name: t('ward_name'), value: ''}, // if not exist this value -> default category: categoryList[0]
                     categoryWidth: 140,
                     categoryHidden: hiddenCategory,
                     disabled: !!!provinceValue?.value || !!!districtValue?.value,
                     placeholder: t('select_ward'),
                     readOnly: true,
                     value: wardValue?.name || '',
                     validateText: props?.size === 'sm' ? validateWard ? (<>&nbsp;</>) : '' : validateWard,
                     validateType: 'danger'
                  }}
                  // search menu dropdown
                  menuProps={{
                     // style: {
                     //   bottom: props?.placement === 'top' ? 40 : 'initial',
                     //   top: props?.placement === 'top' ? 'initial' : 'calc(100% + 4px)',
                     // },
                     empty:
                        wardList.length <= 0 ? t('ward_no_data') : '',
                  }}
                  // search input in dropdown menu
                  searchInputProps={{
                     placeholder: t('search_ward'),
                     value: wardKeyword || '',
                     onChange: onWardKeywordChange,
                  }}
               >
                  {wardList.length > 0 &&
                  wardList.map(item => (
                     <AutoCompleteSingleOption
                        key={item.value}
                        data-active={item.value === wardValue?.value}
                        onClick={() => onWardChange(item)}
                     >
                        {item.name}
                     </AutoCompleteSingleOption>
                  ))}
               </AlternativeAutoComplete>
            </div>
            {
               props?.size === 'sm' && !!validateGroup && <div className='validate-group'>
                  <Text fontSize={12} color={THEME_SEMANTICS.failed}>{t(validateGroup)}</Text>
               </div>
            }
         </div>
      </StyledOldAddress>
   )
}